/* eslint-disable no-template-curly-in-string */
import commons from "./commons/en"
import components from "./components/en"
import forms from "./forms/en"
import models from "./models/en"
import screens from "./screens/en"
import yup from "./yup/en"

export default {
  "bottomMenu" : {
    "home": "Home",
    "graph": "Graph",
    "quickInput": "Input",
    "help": "Support",
    "profile": "Profile"
  },
  "common": {
    "ok": "OK",
    "yes": "Yes",
    "cancel": "Cancel",
    "back": "Back",
    "close": "Close",
    "next": "Next",
    "done": "Done",
  },
  "errors": {
    "invalidEmail": "Invalid email address."
  },
  "welcomeScreen": {
    "poweredBy": "POWERED BY IGNITE",
    "readyForLaunch": "Ready for launch.",
    "continue": "CONTINUE"
  },
  "demoScreen": {
    "howTo": "HOW TO",
    "title": "What’s In This Stack?",
    "tagLine": "Congratulations, you’ve got a very advanced React Native app template here.  Take advantage of this boilerplate!",
    "reactotron": "Demo Reactotron",
    "demoList": "Demo List",
    "androidReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running, run adb reverse tcp:9090 tcp:9090 from your terminal, and reload the app.",
    "iosReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "macosReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "webReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "windowsReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app."
  },
  "demoListScreen": {
    "title": "Demo List"
  },
  "errorScreen": {
    "title": "Something went wrong!",
    "friendlySubtitle": "This is the screen that your users will see in production when an error is thrown. You'll want to customize this message (located in `app/i18n/en.json`) and probably the layout as well (`app/screens/error`). If you want to remove this entirely, check `app/app.tsx` for the <ErrorBoundary> component.",
    "traceTitle": "Error from %{name} stack",
    "reset": "RESET APP"
  },

  "splashScreen": {
    "splashScreenTitle": "Shrimp Farm Management Application",
    "releaseTitle": "What's new in {{version}}",
    "releaseMessage": "",
    "hashtag": "#HadirMembantu"
  },
  "onboardScreen": {
    "onboard1": "Welcome to Jala",
    "onboard2": "Offline mode",
    "onboard3": "Monitor your pond conditions wherever you are",
    "onboard4": "Collaborative farm management",
    "onboard5": "Shrimp price updates and news",
    "onboard6": "Intergrated with Jala Baruno water quality device",
    "login": "Sign In",
    "register": "Register",
    "justTry": "Wanna try it first?",
    "tryDemo": "Try demo"
  },
  "socialLoginScreen": {
    "socialLoginScreenTitle": "Shrimp Farm Management Application",
    "loginWithApple": "Sign In with Apple",
    "loginWithGoogle": "Sign In with Google",
    "loginWithFacebook": "Sign In with Facebook",
    "or": "Or",
    "loginWithEmail": "Sign In with your email",
    "loginWithPhoneEmail": "Sign In with Phone Number or Email"
  },
  "loginScreen": {
    "welcome": "Welcome",
    "loginSubtitle": "Please sign in with the registered email address",
    "email": "Email",
    "emailAddress": "Phone Number or Email Address",
    "password": "Password",
    "forgotPassword": "Forgot password?",
    "login": "Sign In",
    "failedAlert": "Sign In Failed",
    "failedAlertSubtitle": "Make sure your Phone Number/Email and Password is correct"
  },
  "passwordResetScreen": {
    "resetPassword": "Reset Password",
    "forgotPassword": "Forgot Password?",
    "InputForgotPasswordEmail": "Input Your Email",
    "ButtonForgotPassword": "Send Reset Password Link",
    "forgotPasswordSubtitle": "Enter your email address, and we will send you a guide with a password reset link.",
    "guideTitle": "Reset guide has been sent",
    "guideMessage": "check your email to reset the password",
    "failedTitle": "Reset password failed",
    "errorMessage": "We can't find user with those email",

    "phoneModeButton": "Use Phone Number",
    "emailModeButton": "Use Email",
    "sendOTPButton": "Send Verification Code",

    "forgotPasswordWithPhoneSubtitle": "Enter your phone number, we will send a verification code to reset your password.",
    "inputOTPTitle": "Enter the verification code",
    "inputOTPSubtitle": "The verification code has been sent to the number {{phone}}. Please enter the verification code below to proceed. Didn't receive the verification code?",
    "resendOTP": "Resend code",
    "inputNewPassword": "Enter your new password",
    "successTitle": "Password Updated Successfully",
    "successSubtitle": "Your password has been updated successfully. You can now log in with your new password.",

    "sendWhatsappVerification": "Send Verification Code Via WhatsApp",
    "sendSMSVerification": "Send Verification Code Via Message",

    "modalTitleSuccess": "Code Resent Successfully",
    "modalSubtitleSuccess": "You can request an OTP code twice a day. If you exceed the limit, please try again tomorrow. Thank you for using our service.",
    "modalTitleFailed": "Code Sending Limit",
    "modalSubtitleFailed": "You have reached the limit of your OTP code requests for today. Please try again tomorrow to get a new OTP code or Contact Us."
  },
  "registerScreen": {
    "register": "Register",

    "subPatent": "By signing up to Jala, you agree to ",
    "jalaPrivacyAndPolicy": "JALA Terms of Service and Privacy Policy",
    "registerNow": "Register Now",
    "phoneDisclaimer": "Make sure the phone number you entered is correct, because you can only change the phone number once in 24 hours."
  },
  "initialSyncScreen": {
    "loading": "Please wait\nloading data..."
  },

  "registerForm": {
    "name": "Full Name",
    "phone": "Phone Number",
    "email": "Email",
    "password": "Password",
    "passwordConfirmation": "Confirm the password",
    "type": "Occupation",
    "occupation": "As",
    "birthdate": "Date of Birth",
    "knowjalafrom": "How did you know about JALA?",

    "namePlaceholder": "Your Name",
    "phonePlaceholder": " ",
    "emailPlaceholder": "Email Address",
    "passwordPlaceholder": "Password",
    "passwordConfirmationPlaceholder": "Retype Password",
    "farmers": "Farmers",
    "nonFarmers": "Non Farmers",
    "occupationPlaceholder": "Choose",
    "birthdatePlaceholder": "Choose",

    "passwordConfirmationDoesntMatch": "${path} doesnt match",

    "social_media": "Social Media (Facebook, Instagram, TikTok, Youtube)",
    "online_ads": "Online Ads",
    "blog_or_article": "Blog/Article ",
    "offline_attribute": "Offline Attribute (Flyer, Catalog, Banner)",
    "friend_recomendation": "Friend Recomendation",
    "community": "Community",
    "online_event": "Online Event",
    "offline_event": "Offline Event",
    "other": "Others"
  },

  "profileScreen": {
    "profile": "Profile",
    "verified": "Verified",
    "unverified": "Unverified",
    "editProfile": "Edit Profile",
    "farmProfile": "Connected Farm",
    "security": "Security",
    "settingAccount": "Settings",
    "privacyMenu": "Privacy Policy",
    "choice": "Choice",
    "interesTitle": "Personalization Setting",
    "language": "Language",
    "support": "Support",
    "helpMenu": "Help",
    "faq": "FAQ",
    "whatsapp": "Jala WhatsApp",
    "emailMenu": "Email",
    "appsTutorial": "JALA App Tutorial",
    "joinTelegram": "Join Telegram Group",
    "theOther": "Others",
    "rateUs": "Rate Jala",
    "appInfo": "Application Info",
    "exitMenu": "Sign Out",
    "changeLanguage": "Change Language",
    "messenger": "Facebook Messenger",
    "logoutTitle": "Check before Sign Out",
    "logoutSubtitle": "Make sure offline data is '0' before exiting the app. Offline data that has not been uploaded can be deleted if you sign out",
    "logoutButtonConfirm": "Sign Out",
    "logoutButtonCancel": "Back"
  },

  "settingAccount": {
    "setting": "Settings",
    "changePassword": "Change Password",
    "delete": "Delete Account",
    "resetOfflineDatabase": "Reset Offline Database",
    "resetOfflineDatabaseWarn": "You will lost unsent offline records.",
  },

  "changePasswordForm": {
    "currentPassword": "Current Password",
    "password": "New Password",
    "passwordConfirmation": "Confirmation Password",
    "success": "Password successfully changed",
    "oldPasswordError": "Current Password Not Match",
    "failedInput": "Failed, please try again",

    "currentPasswordPlaceholder": "Current Password",
    "passwordPlaceholder": "New Password",
    "passwordConfirmationPlaceholder": "Confirmation Password",

    "passwordConfirmationDoesntMatch": "${path} doesnt match"
  },

  "deleteScreen": {
    "term1": "Data cycle, pond, and farm will be deleted and you can't access it again.",
    "term2": "Account and your private data will be deleted.",
    "term3": "You will no longer connect to another farm.",
    "deletingAccount": "Are you sure you want to delete this account ?",
    "termDelete": "If your account is deleted : ",
    "delete": "Delete",
    "deleteConfirm": "Confirm Password",
    "agreement": "I understand and accept all risks above about delete account.",
    "disclaimer": "Deleted account can't be restored again. If you are sure, please fill in your password to delete the account.",
    "placeholder": "Confirm password"
  },

  "editProfileForm": {
    "header": "Edit Profile",
    "photo": "Edit Profile Photo",
    "name": "Full Name",
    "email": "Email",
    "phone": "Phone Number",
    "gender": "Gender",
    "regionId": "Address",
    "save": "Save",
    "man": "Man",
    "woman": "Woman",
    "takePhoto": "Take a photo",
    "fromGallery": "From gallery",

    "namePlaceholder": "Full name",
    "emailPlaceholder": "Email Address",
    "phonePlaceholder": "Phone Number",
    "genderPlaceholder": "Select Gender",
    "regionIdPlaceholder": "Select Address"
  },

  "connectedFarm": {
    "header": "Connected Farm",
    "as": "As",
    "member": "Member",
    "emptyTitle": "No farm yet",
    "emptySubtitle": "Create your farm or ask your owner to invite you.",
    "farmProfile": "Farm Profile",
    "farmLabel": "Farm Name",
    "address": "Address",
    "area":"Area",
    "addMember": "Add Member",
    "owner": "Owner",
    "admin": "Admin",
    "operator": "Operator",
    "laboran": "Laboratory Assistant",
    "viewer": "Viewer",
    "add": "Add Member",
    "roleId": "Role",
    "roleIdPlaceholder": "Select Role",
    "info": "Information",
    "access1": "Edit farming record",
    "access2": "View farming record",
    "access3": "Access to analysis graph (web app)",
    "access4": "View & edit inventory record (web app)",
    "access5": "Export farming report (web app)",
    "access6": "View and edit financial record (web app)",
    "access7": "Export financial report (web app)",
    "access8": "Add & delete member",
    "access9": "Edit member access",
    "changeAccess": "Change Access",
  },

  "pondScreen": {
    "addFarm": "Create Farm",
    "emptyFarm": "No farm yet",
    "createPond": "Create Pond",
    "addPond": "Add Pond",
    "emptyPond": "No pond",
    "startCycle": "Start Cycle",
    "cycleHistory": "Cycle History",
    "ClosedAt": "Closed at",
    "age": "DoC",
    "temperature": "Temp",
    "do": "DO",
    "ph": "pH",
    "salinity": "Salinity",
    "weather": "Weather",
    "color": "Color"
  },

  "storybook": {
    "placeholder": "Placeholder",
    "field": "Field"
  },

  "graphScreen": {
    "header": "Graph",
    "message": "Please choose the farm, pond,\nand cycle to show the graph",
    "farming": "Cultivation",
    "waterQuality": "Water Quality",
    "costAnalysis": "Cost",

    "profitPotential": "Revenue Potential",
    "productionCost": "COGS Estimation ({{currency}}/kg)",
    "incomePotential": "Profit Potential",
    "estimationFeedCost": "Feed Cost",
    "estimatedSellingPrice": "Selling Price Estimation",
    "production": "Production Cost Estimation",
    "active": "Active Cycle",
    "nonactive": "Non-Active Cycle",
    "revenuePotentialDisclaimer": "Revenue potential = (biomass estimation x shrimp selling price) + harvest ({{currency}})",
    "profitPotentialDisclaimer": "Profit potential = revenue potential - production cost estimation",
    "profitPotntialDisclaimerSubtitle": "Production cost estimation is obtained through a feed cost approach as the largest contribution + other costs estimates.",
    "hppEstimation": "COGS estimation = ",
    "costEstimation": "production cost estimation ({{currency}})",
    "biomassEstimation": "biomass estimation + harvest (kg)",
    "hppEstimationDisclaimer": "Production cost estimation is obtained through a feed cost approach as the largest contribution + other costs estimates.",
    "productionDisclaimer": "Production cost = seed cost + feed cost + estimation others cost",
    "sellingPriceDisclaimer": "Selling price = biomass estimation x count price from COGS estimation",
    "sellingPriceDisclaimer2": "*This cost prediction calculation does not include electricity, employee salaries and cultivation preparation costs.",
    "completeDataDisclaimer": "Complete your feed data to get a more accurate estimation",
    "feedCostDisclaimer": "Feed cost = total feed x feed price",
    "cogsDisclaimer1": "*<b>Electricity cost</b>, <b>employee salary</b> and <b>cultivation preparation costs </b> not included in the estimate calculation.",
    "cogsDisclaimer2": "*This estimation value is only an alternative information for assessing operational aspects of cultivation."
  },

  "diseaseScreen": {
    "shrimpDisease": "Shrimp Disease",
    "diseaseSearchPlaceholder": "Search disease keyword",
    "listDisease": "List Diseases",
    "read": "Read",
    "empty": "Oops, result not found.\nUse another keyword",
    "mostSearch": "or see most searched disease"
  },

  "newsScreen": {
    "shrimpNews": "Shrimp News",
    "newsSearchPlaceholder": "Search shrimp news",
    "latestNews": "Latest News",
    "allCategory": "All Category",
    "other": "See others",
    "search": "Search result from '{{search}}'",
    "searchByCategory": "or search by category",
    "category": "Category"
  },

  "autoFeederScreen": {
    "title": "Auto Feeder",

    "connect": "Connect",
    "mode": "Mode",
    "typeCommand": "Type Command",
    "send": "Send",
    "failedToConnect": "Failed to Connect"
  },

  "autoFeederPondCreateScreen": {
    "title": "Add Auto Feeder",
    "successAddSubtitle": "Your Asto has been successfully added!",
    "successModalSubtitle": "Before using Asto, it is important to configure the connection, play mode and also test run"
  },

  "autofeederCreateQRScanScreen": {
    "title": "Scan QR Code",
    "description": "Point the camera at the qr code image printed on the asto controller",
    "unrecognizedModalTitle": "QR code unrecognized",
    "unrecognizedModalSubtitle": "The QR code is not yet registered in our database, please try to scan again."
  },

  "autoFeederPondCreateWizardScreen": {
    "connectionSetup": "Connection Setup",
    "modeSetup": "Mode Setup",
    "testRunSetup": "Asto Test Run",
    "connectAsto": "Connect the Asto",
    "connectAstoSubtitle": "When operating Asto, you need to connect the asto via a Bluetooth or Wifi network",
    "connectAstoWifi": "Connect the Asto with WiFi (opsional)",
    "connectAstoWifiSubtitle": "You can also connect the Asto with a wifi network in Farm",
    "testRunSubtitle": "Test the asto controller, make sure it is connected to your Autofeeder",
    "testRunModalTitle": "Did the Autofeeder running?",
    "hold": "Press to start",
    "bluetooth": "Bluetooth",
    "bluetoothDisconnected": "Disconnected. Touch to connect it",
    "ssid": "WiFi SSID",
    "password": "WiFi Password",
    "connect": "Connect",
    "optional": "*You can skip this stage",
    "modeSetupSubtitle": "Choose one of the modes according to the current conditions in your pond",
    "normal": "Normal",
    "normalDescription": "Feeding on a certain schedule in a day",
    "continue": "Continue",
    "continueDescription": "Continuous feeding until the end of the feed time",
    "timesPerDay": "Feeding Total",
    "debit": "Feed Debit",
    "intervalPeriod": "Feed Duration",
    "onTime": "Timer ON",
    "interval": "Time Interval",
    "startTime": "Start Time",
    "endTime": "End Time",
    "debitUnit": "gr/second",
    "intervalPeriodUnit": "minutes",
    "onTimeUnit": "seconds",
    "timesPerDayUnit": "times/day",
    "debitError": "Feeding minimum in a day is 5 and the maximum is 7",
    "intervalHelper": "Interval by system ",
    "onHelper": "Timer ON by system ",
    "timerOnInfo": "The duration of the motor once rotate",
    "successModalTitle": "Congratulations you have completed the Asto configuration",
    "successModalSubtitle": "Next, you will be directed to get to know the functions of the Asto feature",
    "infoTestRun": "Test Run will proceed accordingly ",
    "infoTestRunOnTime": "Timer ON: {{onTime}} seconds",
    "throwingDistance": "Throwing Distance",
    "short": "Short",
    "medium": "Medium",
    "long": "Long",
    "manual": "Set rotation duration (manual)",
    "duration": "Duration",
    "timesPerDayHelper": "You can charge between 1 and 7 times/day",
    "distanceHelper": "The throw distance of the feed depends on the feed size."
  },

  "autoFeederPondDetailScreen": {
    "title": "Asto Detail",

    "mode": "Mode",
    "debit": "Feed Debit",
    "throwDebit": "Feed Debit",
    "startTime": "Start Time",
    "endTime": "End Time",
    "onTime": "Timer ON",
    "timesPerDay": "Feed per Day",
    "timesPerPeriod": "Throw per Feeding",
    "intervalPerPeriod": "Throw Interval",
    "intervalPeriod": "Feed Duration",
    "duration": "Duration",
    "frequency": "Frequency",
    "quantity": "Feed",
    "interval": "Timer Interval",
    "onTimeOverride": "Manual Timer ON",
    "intervalOverride": "Manual Timer Interval",
    "lastOnAt": "Last ON",
    "previousOnAt": "Previous ON",
    "nextOnAt": "Next ON",

    "intervalShort": "Interval",
    "override": "Manual",

    "debitUnit": "gr/s",
    "throwDebitUnit": "gr/throw",
    "onTimeUnit": "s",
    "timesPerDayUnit": "times",
    "timesPerPeriodUnit": "times",
    "intervalPeriodUnit": "minute(s)",
    "intervalUnit": "minute(s)",

    "intervalUnitShort": "m",

    "today": "Today",
    "nextDay": "Next day",
    "date": "Date",
    "time": "Time",

    "feedData": "Cycle Feed Data",
    "openFeedData": "Open Feed Data",
    "setFeedData": "Use Feed Data",

    "portion": "Portion (kg)",
    "feedPortion": "Feed Portion",
    "feedPortionHelper": "Feed Portion 1 of %{total} Auto Feeder",

    "failedToConnect": "Failed to Connect",
    "uploadOrResetFirst": "Upload or reset first",

    "normal": "Normal",
    "continuous": "Continuous",

    "feedTableTitle": "Feed Table",
    "feedCycleTitle": "Cycle Feed Data",
    "todayFeedTitle": "Today Feed",

    "weeklySchedule": "Weekly Feed Schedule",
    "detail": "Detail(kg)",
    "detailInfo": "Details depends on the feed time",
    "intervalInfo": "Time interval between rounds",
    "durationInfo": "Motor duration per rotation",

    "feedCycleDataDescription": "You can use the feed data that has been inputted in the Feed Input feature",
    "disconnectedWarning": "Connection Lost",
    "disconnectedWarningDescription": "You're not connected with the Asto",

    "confirmationSaveTitle": "Save the Data?",
    "confirmationSaveSubtitle": "Are you sure you want to save the data?",
    "confirmationUploadTitle": "Upload the Data?",
    "confirmationUploadSubtitle": "Are you sure you want to upload the data?",
    "confirmationResetTitle": "Reset the Data?",
    "confirmationResetSubtitle": "Are you sure you want to reset the data?",

    "intervalDataTitle": "Interval Data",
    "feedWarning": "The amount of feed in the tank is running low, check it now!",

    "uploadWarning": "There are changes in ASTO data that haven't been uploaded.",
    "uploadData": "Upload Data",

    "feedDataTitle": "Feed Data",
    "failedConnect": "Failed to Connect. Touch to connect it",

    "uploadBannerTitle": "Data has not been sent to ASTO.",
    "uploadBannerSubtitle": "Upload data changes to update settings on the autofeeder.",
    "uploadBannerButton": "SEND",
    "uploadSuccessTitle": "Upload Successful!",
    "uploadSuccessSubtitle": "Settings have been successfully saved to ASTO",
    "sendToAsto": "Send to ASTO",

    "advancedSetting": "Advanced Settings",

    "calibrationTitle": "Was the feed running out not as expected?",
    "calibrationButton": "Adjust Feed Debit",
    "calibrationModalTitle": "Feed Debit Adjustment",
    "calibrationModalSubtitle": "Input data according to conditions and we will adjust the debit for the next feeding.",
    "calibrationChooseTitle": "Today, My Feed",
    "under": "Finished earlier",
    "over": "Still remain",
    "actualEndTime": "Feed finished at",
    "actualEndTimeAsk": "What time did it finish?",
    "actualIntervalPeriod": "Feeding duration finished",
    "remainingQuantity": "Estimated remaining feed",
    "expectedQuantity": "Total previous feed",
    "confirmationTitle": "Is the data correct?",
    "confirmationButton": "Yes, it's correct",
    "changes": "Changes:",
    "debitBefore": "Debit before",
    "debitAfter": "Debit after",
    "cancelButton": "Back",
    "successTitle": "Successfully Saved!",
    "successSubtitle": "Adjustment will be made in the next feed delivery.",
    "close": "Close"
  },

  "autoFeederPondEditScreen": {
    "title": "Auto-feeder Setting",

    "connection": "Connection",
    "general": "General",
    "normal": "Normal",
    "continuous": "Continuous",
    "misc": "Misc",

    "bluetooth": "Bluetooth",
    "wifi": "WiFi",
    "ssid": "SSID",
    "password": "Password",

    "mode": "Mode",
    "debit": "Feed Debit (gr/s)",
    "throwDebit": "Feed Debit (gr/throw)",
    "startTime": "Start Time",
    "endTime": "End Time",
    "onTime": "Timer ON (second(s))",

    "timesPerDay": "Times per Day",
    "timesPerPeriod": "Throw times per feeding",
    "intervalPerPeriod": "Throw interval (minute(s))",
    "intervalPeriod": "Feed duration (minute(s))",

    "onTimeUnit": "second(s)",

    "testRun": "Test Run",
    "clearSetting": "Clear Setting",
    "disconnect": "Disconnect",
    "delete": "Delete",

    "connected": "Connected",
    "disconnected": "Disconnected",
    "connecting": "Connecting...",
    "tapToReconnect": "Tap to Reconnect",
    "tapToConnect": "Tap to Connect",
    "tapToRefresh": "Tap to Refresh",

    "failedToConnect": "Failed to Connect",
    "continuousSetting": "Basic Settings for Continuous Mode",
    "normalSetting": "Basic Settings for Normal Mode"
  },

  "autoFeederPondActivityListScreen": {
    "title": "Auto Feeder Activity",
    "subtitle": "within a week"
  },

  "autoFeederPondForm": {
    "farmId": "Farm",
    "pondId": "Pond",
    "id": "ID",
    "name": "Name",
    "mode": "Mode",
    "updatedAt": "Updated At",
    "autoFeeder": "Auto Feeder",

    "farmIdPlaceholder": "Select Farm",
    "pondIdPlaceholder": "Select Pond",
    "idPlaceholder": "ID",
    "namePlaceholder": "Name",
    "modePlaceholder": "Mode",
    "updatedAtPlaceholder": "Updated At",
    "autoFeederPlaceholder": "Select Auto Feeder",

    "enableBluetoothTitle": "Aktifkan Bluetooth",
    "enableBluetoothSubtitle": "Setelah Bluetooth aktif, Anda dapat melanjutkan dengan menambahkan asto ke perangkat Anda.",
    "enableBluetoothConfirm": "AKTIFKAN",
    "enableBluetoothCancel": "NANTI"
  },

  "farmPondListScreen": {
    "header": "Create Pond",
    "title": "Ponds",
    "lastUpdate": "Last Update %{datetime}",
    "noUpdate": "No update within last week",
    "noRecord": "No cycle. Please Start Cycle to begin the cultivation",
    "number": "Total Pond",
    "pondName": "Pond Name",
    "total": "{{pond}} ponds",
    "pondTooltip": "Create pond so you can write down data immediately.",
    "createCycle": "Start cycle to enjoy Jala services",

    "initialDataLoading": "Initial Data Loading"
  },
  "farmAutoFeederPondListScreen": {
    "title": "Auto Feeders",
    "asto": "Asto",
    "addAsto": "Add Asto",
    "astoList": "Asto List",

    "feed": "Feed: %{feed} kg",
    "noDevices": "No devices",
    "mode": "Mode: %{mode}",
    "todayFeed": "Today feed",
    "lastUpdate": "Last update",
    "lastUploaded": "Last uploaded",
    "playMode": "Play mode",
    "nextDayFeed": "Next day feed",

    "farm": "Farm",
    "normal": "Normal",
    "continuous": "Continuous",

    "emptyStateTitle": "You haven't add Asto",
    "emptyStateSubtitle": "To use this feature, you need to add Asto.",
    "emptyStateButton": "Add Asto",

    "orderTitle": "Don't have Asto yet?",
    "orderButton": "Order Now",

    "cycleClosedTitle": "No active cycle",
    "cycleClosedSubtitle": "You need to create a new cycle.",
    "cycleLaterButton": "LATER",
    "createCycleButton": "CREATE CYCLE"
  },
  "measurementCreateScreen": {
    "title": "Add Data Water Quality"
  },
  "measurementEditScreen": {
    "title": "Edit Data Water Quality"
  },

  "createPondForm": {
    "farm": "Create Ponds for Farm",
    "prefix": "Pond Name Prefix",
    "name":"Pond Name",
    "length":"Length (m)",
    "width":"Width (m)",
    "wide": "Wide (m2)",
    "depth": "Depth (m)",
    "type": "Pond Type",
    "square": "Square",
    "circle": "Circle",
    "diameter": "Diameter (m)",
    "nameError": "Name already used in another pond",
    "prefixDisclaimer": "Numbering will automatically follow the number of ponds",
    "inputTitle": "Pond list",
    "inputDisclaimer": "Change the pond area according to actual so that the calculation of the Jala estimation is more appropriate.",

    "namePlaceholder":"Pond Name",
    "lengthPlaceholder":"-",
    "widthPlaceholder":"-",
    "widePlaceholder": "-",
    "depthPlaceholder": "-",
    "diameterPlaceholder": "-",
    "prefixPlaceholder": "Pond Name Prefix",
  },

  "quickInput": {
    "farming": "Farming",
    "daily": "Daily",
    "LabTest": "Laboratorium Test",
    "Others": "Others",
    "startCycle": "Start Cycle",
    "sampling": "Sampling",
    "harvest": "Harvest & Partial",
    "closeCycle": "Close Cycle",
    "createFarm": "Create Farm",
    "createPond": "Create Pond",
    "feed": "Feed",
    "waterQuality": "Water Quality",
    "treatment": "Treatment",
    "feedingTray": "Feeding Tray",
    "chemical": "Chemical",
    "microbiology": "Microbiology",
    "plankton": "Plankton",
    "disease": "Diseases",
    "mortality": "Mortality",
    "quickInputTitle": "Quick Input"
  },

  "phoneInput": {
    "chooseCountry": "Select Country"
  },

  "picker": {
    "choose": "Choose"
  },

  "bluetoothPicker": {
    "scanQr": "Scan QR"
  },

  "predictions": {
    "activePond": "active Ponds",
    "#": "#",
    "biomasPrediction": "Biomass Prediction",
    "feedCumulative": "Feed cumulative",
    "SrPrediction": "SR Prediction",
    "SeliingPricePrediction": "Selling Price Prediction"
  },

  "monitoring": {
    "batch": "Batch",
    "label": "Select Batch",
    "cyclesCount": "Cycle(s)",
    "disclaimer": "Complete your data so that the estimation in the app is closer to the actual data. Any complaint about JALA App?",
    "feedback": "Give us feedback",
    "weight": "MBW (g)",
    "size": "Count",
    "totalWeight": "Total biomass (kg)",
    "harvestAccumulationWeight": "Harvest cumulative (kg)",
    "adg": "ADG (g)",
    "feedAccumulation": "Feed Total (kg)",
    "survivalRate": "SR Estimation (%)",
    "fcr": "FCR estimation",
    "disclaimerMonitoring": "Complete feed and sampling data for more accurate estimation",
    "disclaimerMonitoringBefore30": "Complete feed data for more accurate estimation",
    "seePond": "See Pond",
    "parameter": "Parameter",
    "actual": "Actual (DoC)",
    "pondPopulate": "Pond population (%)",
    "estimation": "Today estimation",
    "empty": "Data not found"
  },

  "samplingInput": {
    "title":"Add Sampling Data",
    "inputTitle": "Sampling"
  },

  "treatmentInput": {
    "title":"Add treatment data"
  },

  "harvestInput": {
    "title":"Add Harvest Data",
    "inputTitle": "Harvest"
  },

  "cycleDiseaseInput": {
    "title": "Add Disease Data"
  },

  "chemical": {
    "header": "Chemical",
    "date": "Date (DoC)",
    "Ammonia": "NH3",
    "Nitrit": "NO2",
    "Alkalinity": "Alkalinity",
    "more": "More",
    "inputTitle":"Add chemical data",
    "changeParam": "Change the parameter list"
  },

  "chemicalForm" : {
    "farmId": "Farm",
    "pondId": "Pond",
    "header": "Chemical Test",
    "measuredDate": "Date",
    "ammonia": "Ammonia (NH3) (ppm)",
    "nitrit": "Nitrit (NO2) (ppm)",
    "alkalinity": "Alkalinity (ppm)",
    "ammonium": "Ammonium (NH4) (ppm)",
    "nitrat": "Nitrat (NO3) (ppm)",
    "carbonat": "Carbonat (CO3) (ppm)",
    "bicarbonat": "Bicarbonat (HCO3) (ppm)",
    "hardness": "Hardness (ppm)",
    "calcium": "Calcium (Ca) (ppm)",
    "magnesium": "Magnesium (Mg) (ppm)",
    "phosphate": "Phosphate (PO4) (ppm)",
    "tom": "Total organic matter (TOM) (ppm)",
    "orp": "Oxidation-Reduction Potential (ORP) (ppm)",

    "farmIdPlaceholder":"Select Farm",
    "pondIdPlaceholder": "Select Pond",
    "measuredDatePlaceholder": "Select Date",
    "ammoniaPlaceholder": "-",
    "nitritPlaceholder": "-",
    "alkalinityPlaceholder": "-",
    "ammoniumPlaceholder": "-",
    "nitratPlaceholder": "-",
    "carbonatPlaceholder": "-",
    "bicarbonatPlaceholder": "-",
    "hardnessPlaceholder": "-",
    "calciumPlaceholder": "-",
    "magnesiumPlaceholder": "-",
    "phosphatePlaceholder": "-",
    "tomPlaceholder": "-",
    "orpPlaceholder": "-"
  },

  "pondProfileForm": {
    "setting": "Pond Setting",
    "delete": "Delete pond",
    "name": "Pond Name",
    "rfid": "RFID Number (Optional)",
    "rfidTitle": "RFID Number",
    "rfidSubtitle": "RFID is a card you got when you bought Baruno, inside it there are 8 digit codes that you can register to identify pond.",
    "length": "Length (m)",
    "width": "Width (m)",
    "diameter": "Diameter (m)",
    "area":"Area (m2)",
    "deep": "Deep (m)",
    "createdAt": "Date Created",
    "feedingTrayCount": "Feeding Tray",
    "type": "Pond Type",
    "square": "Square",
    "circle": "Round",
    "existingName": "This name is already used in your other pond",
    "warning": "Changing the pond area will not affect prediction calculations for the ongoing or previous cycle, but will affect predictions for the next cycle.",
    "rfidNotFound": "No results found",
    "rfidLabel": "RFID",
    "success": "Data saved successfully",
    "failed": "Data failed to save, please check your internet connection and try again",
    "editPondDesc": "Changing the pond area will not affect prediction calculations for the ongoing or previous cycle, but will affect predictions for the next cycle.",
    "visit": "*Visit",

    "namePlaceholder": "Pond Name",
    "rfidPlaceholder": "Input 8 code letters",
    "lengthPlaceholder": "-",
    "widthPlaceholder": "-",
    "areaPlaceholder":"-",
    "deepPlaceholder": "-",
    "diameterPlaceholder": "-",
    "createdAtPlaceholder": "Select Date",
    "feedingTrayCountPlaceholder": "Select Feeding Tray",

    "deleteModalTitle": "Are you sure you want to delete the Pond?",
    "deleteModalSubtitle": "If you are sure, type ",
    "deleteModalSubtitleLast": "to confirm the pond you want to delete.",
    "pondNamePlaceholder": "Type the pond name",
    "confirmDeleteButton": "YES, DELETE",
    "cancelDeleteButton": "CANCEL",
    "modalErrorMessage": "Type “{{pond}}”"
  },

  "cycleHistoryScreen": {
    "header": "Cycle History",
    "days": "days",
    "kg": "kg",
    "percent": "%",
    "age": "Age",
    "harvest": "Harvest",
    "seed": "Seeds",
    "fcr": "FCR",
    "size": "Count",
    "survival": "SR"
  },

  "personalisationScreen": {
    "header": "Personalization Setting",
    "PersonalizationTitle": "Set the homepage view based on what you're going for",
    "PersonalizationSubtitle": "To set the view, pick one or more interests below.",
    "button": "Next"
  },

  "verificationScreen": {
    "title": "Verify your phone number",
    "subtitle": "Check your phone number {{phone}} for the OTP code.",
    "subtitleOld": "Help us authenticate your phone number by entering OTP code we’ve sent to {{phone}}",
    "warningOld": "Please verify your phone number within {{day}} days {{hour}} hours",
    "verificationInfo": "You can use Jala right after you verify your phone number",
    "codeVerificationError": "OTP code is incorrect or expired",
    "placeholderOTP": "6 digit OTP code",
    "resendOTP": "Resend OTP",
    "cantVerify": "Can't get OTP Code?",
    "contactUs": " Contact Us",
    "verificationButton": "Enter OTP Code",
    "inputBeforeExpired": "Enter OTP code within {{seconds}} seconds",
    "changePhoneTitle": "Change phone number",
    "changePhoneSubtitle": "We will send a new OTP code to the phone number you enterred below.",
    "verification": "Verification",
    "verificationWarning": "Verify your phone number within {{day}} days",
    "inputPhoneTitle": "Enter phone number",
    "inputPhoneSubtitle": "Help us to verify your account, start by entering your phone number.\nAn OTP code will be sent via SMS.",
    "changeNumberButton": "Change phone number and resend OTP",
    "verifExpired": "Complete verification to continue to dashboard",
    "whatsappMessageVerification": "Please help me verify my phone number {{phoneNumber}}",
    "whatsappMessageVerificationEmail": "Please help me verify my email {{email}}",
    "changePhone": "Change phone",
    "phoneVerificationTitle": "Phone Verification",
    "phoneChangeTitle": "Change Phone",

    "phoneWarning": "Unable to change number because it was changed in the last 24 hours",
    "phoneError": "Phone number not valid",
    "phoneDisclaimer": "You can only change your number once in 24 hours. Contact Us for other questions.",

    "verificationFailed": "Verification Failed",
    "OTPLimited": "Failed to get the OTP\nUse other phone number or Contact Us."
  },

  "infoAppScreen": {
    "title": "Application Info",
    "header": "Shrimp farming management application",
    "thanks": "Thanks to beta tester",
    "madeIn": "Made in Indonesia",
    "credit": "© 2022 PT JALA Akuakultur Lestari Alamku"
  },

  ...components,
  ...forms,
  ...screens,
  ...models,
  ...commons,
  yup,

  "privacyPolicy": "Privacy Policy",

  "thunderStorm": "ThunderStorm",
  "rain": "Rain",
  "drizzle": "Drizzle",
  "cloudy": "Cloudy",
  "sunnyCloudy": "Sunny & Cloudy",
  "sunny": "Sunny",
  "scorching": "Scorching",
  "none": "None",

  "yellow": "Yellow",
  "yellowGreen": "Yellow Green",
  "brown": "Brown",
  "brownGreen": "Brown Green",
  "darkBrown": "Dark Brown",
  "lightBrown": "Light Brown",
  "brownRed": "Brown Red",
  "green": "Green",
  "greenBrown": "Green Brown",
  "greenBlue": "Green Blue",
  "darkGreenBrown": "Dark Green Brown",
  "darkGreen": "Dark Green",
  "black": "Black",

  "Search": "Search",
  "Clear": "Clear",
  "Close": "Close",
  "Finished": "Finished",
  "Please Wait": "Please Wait",
  "Network Error": "Network Error",
  "language": "Language",
  "total": "Total",
  "average": "Average",
  "million": "Million",
  "millionPerKg": "/kg",
  "doc": "DoC",
  "Today": "Today",
  "SRWithPercent": "SR(%)",
  "Size": "Count",
  "Biomass": "Biomass",
  "harvest": "Harvest",
  "cycle": "Cycle",
  "date": "Date",
  "time": "Time",
  "noPond": "no Pond",
  "save": "Save",
  "connect": "Connect",
  "add": "Add",
  "edit": "Edit",
  "delete": "Delete",
  "cancel": "Cancel",
  "failed": "Failed",
  "success": "Success",
  "upload": "Upload",
  "uploading": "Uploading",
  "override": "Override",
  "offlineModeContent": "Data is temporarily stored on your device. Immediately upload data when the signal is sufficient.",
  "offlineModeWeakConnection": "Weak Connection",
  "Errors": "Errors",
  "reset": "Reset",
  "farmingSummary": "Farming Summary",
  "cycleHistory": "Cycle History",
  "pondProfile": "Pond Settings",
  "cycleProfile": "Cycle Settings",
  "searchPondPlaceholder": "Search Pond...",
  "paramTooltip": "Click here to input another data parameter",

  "and": "and",
  "noData": "no data",

  "areYouSureYouWantTo": "Are you sure you want to do %{something}?",

  "LongNet": "Net (Amount you ordered)",
  "LongGross": "Gross (Amount received from hatchery)",
  "LongActual": "Actual (Actual amount counted)",

  "Net": "Net",
  "Gross": "Gross",
  "Actual": "Actual",

  "cantBeZero": "Input can't be 0",
  "validationInput": "This field is required",
  "otherParameters": "Other Parameters",
  "minPassword": "Password must be at least 6 characters",
  "cantBeMinus": "Input can't be less than 0",

  "filter": "Filter",
  "addNote": "Notes",

  "now": "Now",

  "fetchingData": "Fetching data...",
  "offline": "Offline record stored",

  "changeLanguage": {
    "title": "Languages Option",
    "Indonesia": "Indonesia (ID)",
    "english": "English (EN)",
    "vietnamese": "Vietnamese (VN)",
    "espanol": "Español (ES)"
  },

  "checkLink": "Check this link: {{url}}",
  "shareDiseaseTitle": "Shrimp disease info: {{disease}}",
  "failedShared": "Share failed, please try again later",
  "shareNewsTitle": "Would you read this Jala article? {{news}}.",
  "sharePriceTitle": "Update {{date}}, shrimp price (count 100) - {{region}}",
  "copiedToClipboard": "Copied to clipboard",

  "posts": {
    "read_complete_article_only_on": "read complete article only on"
  },

  "notifications": {
    "infoHeader": "Shrimp Price",
    "farmingHeader": "Farming",
    "priceNotificationTitle": "New shrimp price in region",
    "readAll": "Mark all as read",
    "waitingForLoad": "Loading New Notifications",
    "emptyNotification": "Empty New Notifications",
    "refreshPage": "Refresh Page",
  },

  "NewFeature": "New Feature! {{featureName}}",
  "AlertFailedTitle": "Failed",
  "AlertFailedAuthSubtitle": "Sign in failed",
  "AlertFailedRegisSubtitle": "Registration failed",
  "AlertWrongInput": "Invalid email / password",
  "AlertServerUnreachable": "Server unreachable",
  "AlertServerFail": "Sorry, something wrong with the server",
  "AlertUserNotFound": "Make sure your e-mail or password is correct",
  "AlertUserUnauthenticated": "User not found, please register or re-sign in",
  "AppleSignInNotSupported": "Sorry, your iOs version could not sign in using Apple ID. Please update your iOs version or sign in using another option",

}
